import React from 'react';

import { bemCssModules } from '@utils';

import ArrowIcon from './arrow.svg';

import style from './TitleWithArrow.scss';

const cn = bemCssModules(style, 'TitleWithArrow');

export type TTitleWithArrow = {
  text: string;
};

export const TitleWithArrow: CustomFC<TTitleWithArrow> = ({ className, text }) => (
  <h2 className={cn(null, ['h2', className])}>
    {text} <ArrowIcon className={cn('arrow')} />
  </h2>
);

export default TitleWithArrow;
